import { CurrencyPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appCurrency]'
})
export class CurrencyDirective implements OnInit {
  
  // build the regex based on max pre decimal digits allowed
  private regexString(max?: number) {
    const maxStr = max ? `{0,${max}}` : `+`;
    return `^(\\d${maxStr}(\\.\\d{0,2})?|\\.\\d{0,2})$`
  }
  private digitRegex: RegExp | undefined;
  private setRegex(maxDigits?: number) {
    this.digitRegex = new RegExp(this.regexString(maxDigits), 'g')
  }
  @Input()
  set maxDigits(maxDigits: any) {
    this.setRegex(maxDigits);
  } 

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: CurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
    this.setRegex();
  }

  ngOnInit() {
    this.el.value = this.currencyPipe.transform(this.el.value, 'USD') ?? '';
  }

  @HostListener("focus")
  onFocus() {
    // on focus remove currency formatting
    this.el.value = this.el.value.replace(/[^0-9.]+/g, '');
    this.el.select();
  }

  @HostListener("blur")
  onBlur() {
    // on blur, add currency formatting
    this.el.value = this.currencyPipe.transform(this.el.value, 'USD') ?? '';
  }

  @HostListener("keydown.control.z")
  onUndo() {
    this.el.value = '';
  }

  // variable to store last valid input
  private lastValid = '';
  @HostListener('input')
  onInput() {
    // on input, run regex to only allow certain characters and format
    const cleanValue = (this.digitRegex ? this.el.value.match(this.digitRegex) || [] : []).join('');
    if (cleanValue || !this.el.value)
      this.lastValid = cleanValue;
    this.el.value = cleanValue || this.lastValid;
  }

}
